import RecuperationLink from './RecuperationLink';

export default RecuperationLink;
